let latestSearchRequestId = 0;

/** 发起新的搜列请求前调用，返回本次请求序号 */
export const beginSearchListRequest = (): number => {
  latestSearchRequestId += 1;
  return latestSearchRequestId;
};

/** 仅当序号仍为最新时，才应采纳本次响应 */
export const isActiveSearchListRequest = (requestId: number): boolean =>
  requestId === latestSearchRequestId;
